module.exports = __webpack_public_path__ + "static/img/8en.bb75b75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/8en.png
// module id = JRO4
// module chunks = 0